import styled, { css } from 'styled-components';

export const FinishStepContainer = styled.div`
    padding: 64px;
    max-width: 800px;

    margin: 52px auto 0 auto;

    ${(props) => props.theme.breakpointTo.sm} {
        padding: 24px;
    }

    ${(props) =>
        props.theme.isLandscape &&
        css`
            ${props.theme.orientation.landscape} {
                padding: 0;
                background-color: ${props.theme.palette.primaryA7};
            }
        `}

    .finish-title {
        ${(props) => props.theme.typography.h2};
        color: ${(props) => props.theme.palette.textMain};
        margin: 0 auto;
        white-space: break-spaces;
        max-width: 440px;

        ${(props) => props.theme.breakpointTo.sm} {
            ${(props) => props.theme.typography.h3};
            font-size: 20px !important;
        }

        .alt-title {
            ${(props) => props.theme.breakpointTo.sm} {
                color: ${(props) => props.theme.palette.textLight};
                max-width: 200px;
                font-size: 16px;
                display: block;
                margin: 4px auto 0 auto;
            }
        }
    }

    .finish-description {
        margin-top: 32px;
        margin-bottom: 0;
        text-align: center;
        ${(props) => props.theme.typography.textBold}
        color: ${(props) => props.theme.palette.textLight};

        ${(props) => props.theme.breakpointTo.sm} {
            max-width: 200px;
            margin: 16px auto 0 auto;
            font-size: 16px;
            line-height: 26px;
        }

        span {
            color: ${(props) => props.theme.palette.primaryA1};
        }
    }

    .text {
        ${(props) => props.theme.typography.text};
        color: ${(props) => props.theme.palette.textLight};
        text-align: center;
    }

    .icon {
        margin-bottom: 20px;
        text-align: center;
        color: ${(props) => props.theme.palette.secondaryA3};

        svg {
            width: 64px;
            height: 64px;
        }

        &-success {
            color: ${(props) => props.theme.palette.secondaryA3};

            img {
                width: 64px;
            }
        }
    }

    .header {
        margin-bottom: 40px;
        text-align: center;
    }

    .main {
        //min-height: 100px;
        display: flex;
        margin-bottom: 28px;
        flex-wrap: wrap;

        & > div {
            margin-right: 80px;

            &:last-child {
                margin-right: 0;
            }
        }

        ${(props) => props.theme.breakpointTo.xs} {
            flex-direction: column;
            gap: 24px;

            & > div {
                display: flex;
                align-items: center;
                gap: 12px;

                .status__title {
                    margin-bottom: 0;
                }
            }
        }
    }

    .footer {
        ${(props) => props.theme.typography.text};
    }

    .actions {
        margin-top: 20px;
        gap: 16px;
        display: flex;

        ${(props) => props.theme.breakpointTo.xs} {
            flex-direction: column;
        }
    }

    .button-redirect {
        margin: 48px auto 0 auto;
        display: flex;

        ${(props) => props.theme.breakpointTo.xs} {
            display: flex;
            position: fixed;
            bottom: 16px;
            left: 16px;
            right: 16px;
            margin: 0;
        }
    }
`;
